import { Dialog, Slide } from '@material-ui/core';
import { Close } from '@mui/icons-material';
import React from 'react';
import ButtonComponent from '../../Inputs/ButtonComponent';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DistributorSingleProductPopUp = ({ productOpen, setProductOpen }) => {
    console.log("productOpen",productOpen)
  return (
    <Dialog
      open={!!productOpen}
      TransitionComponent={Transition}
      onClose={() => setProductOpen(null)}
      maxWidth="sm"
    >
      <div style={{ padding: 24 }}>
        <div style={{ textAlign: 'right' }}>
          <Close onClick={() => setProductOpen(null)} style={{ cursor: 'pointer' }} />
        </div>
        <h3 className='text-center font-bold pb-[20px] text-[20px]'>Product Detail's</h3>
        <div style={{ borderBottom: '1px solid #ccc', margin: '16px 0' }}></div>
        <h6 className='font-bold'>{productOpen?.title}</h6>
        <div style={{ borderBottom: '1px solid #ccc', margin: '16px 0' }}></div>
        <p dangerouslySetInnerHTML={{ __html: productOpen?.description1 }} />
        <div style={{ borderBottom: '1px solid #ccc', margin: '16px 0' }}></div>
        <p dangerouslySetInnerHTML={{ __html: productOpen?.description2 }} />
        <div className='text-center'>
        <ButtonComponent onClick={() => setProductOpen(null)}>Close</ButtonComponent>
        </div>
      </div>
    </Dialog>
  );
};

export default DistributorSingleProductPopUp;
